export default {
  styleOverrides: {
    root: {
      lineHeight: '1em',
      overflow: 'visible',
      whiteSpace: 'normal',
      maxWidth: 'none',
      '&.MuiInputLabel-shrink': {
        maxWidth: 'none',
      },
    },
    outlined: {
      transform: 'translate(14px, 20px) scale(1)',
      '&.MuiInputLabel-shrink': {
        transform: 'translate(14px, -6px) scale(0.75)',
      },
      '.MuiFormControl-marginDense &': {
        transform: 'translate(14px, 12px) scale(1)',
        '&.MuiInputLabel-shrink': {
          transform: 'translate(14px, -6px) scale(0.75)',
        },
      },
    },
  },
};
